import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class Structure extends Component {
    constructor(props)
    {
        super(props);

        this.fetchStructure = this.fetchStructure.bind(this);
        this.generatePDF = this.generatePDF.bind(this);



        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            structure:{},
            term: "",
            server_response:"",
            api_error:true,
            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }




  fetchStructure()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/student/feestructure";

            superagent
            .post(url)
            .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                    student_class:_this.props.student_details.core_details.class})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);

              _this.setState({structure:res.body.fee_structure,server_response:res.body.message,  term:res.body.term, loading:false, loaded_successfully:true, api_error_message:"",server_changes_made:true});



            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, server_response:err, loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }



  renderDownloadButton()
  {
    const _this = this;
      const structureArr = Object.entries(this.state.structure);
      if(_this.structurArr.length > 0 &&  _this.state.server_changes_made)
      {
          return(
                <button className="btn btn-primary btn-round" onClick={_this.generatePDF.bind(_this)} >Download<div className="ripple-container"></div></button>

          );
      }
      else{
          return null;
      }
  }



  renderStructure()
  {
    const _this = this;

  if(_this.props.student_details.class_details.Semester && _this.props.student_details.class_details.Year)
  {

      if(_this.state.structure && !this.state.api_error)
      {

        const structureArr = Object.entries(_this.state.structure);

        let total = 0;

        if(structureArr.length > 0 )
        {
          let invoice_list = structureArr.map(invoice =>
              {
                total = total + invoice[1];
              return (
                  <tr>
                      <td>
                          {invoice[0]}
                      </td>
                      <td>
                          {this.props.renderInThousands(invoice[1])}
                      </td>
                  </tr>
                      );
              });

              return (
                <div className="col-lg-10 col-md-6 col-sm-10 col-xs-11 ">
                              <div className = "report-header" className ="row block-centered col-lg-12 col-md-12 full-width">
                                  <span className="col-lg-12 block-centered"><center><img src ="/img/logotuc.png" className="header-logo center"/> </center></span>
                                  <span className = "col-lg-12 center-align times-n header-name">TURKANA UNIVERSITY COLLEGE</span>
                                  <span className = "col-lg-12 center-align comic header-address">(CONSTITUENT COLLEGE OF MASINDE MULIRO UNIVERSITY OF SCIENCE AND TECHNOLOGY)</span>
                                  <span className = "col-lg-12 center-align comic header-address">P.O BOX 69-30500 LODWAR- KENYA</span>
                                </div>
                                

                        <table className="table">

                                <thead className="text-warning">
                                    <tr>

                                        <th>Item</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {invoice_list}
                                <tr>
                                    <td>
                                        Total
                                    </td>
                                    <td>
                                        {this.props.renderInThousands(total)}
                                    </td>
                                </tr>

                                </tbody>
                        </table>

                </div>
              );
        }

      }
      else {
        return (<p className = "text-center full-width" style ={{paddingTop:"15px", paddingBottom:"15px", color:"red"}}> {_this.state.server_response}</p>)
      }

  }
  else
  {
    return (<p className = "text-center full-width" style ={{paddingTop:"15px", paddingBottom:"15px", color:"red"}}> Current Semester and Year has not been set for your class, hence Fee Structure cannot be generated. Please contact your department.</p>)
  }


  }

  generatePDF()
  {
    const input = document.getElementById('slip');

    html2canvas(input)
    .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 0, 0);
        pdf.save("slip1.pdf");
      });

  }

  componentWillMount()
  {

    if(this.props.student_details.class_details.Semester &&  this.props.student_details.class_details.Year)
    {
      this.fetchStructure();
    }
   
  }

  render() {

    const _this=this;

    let main_content;


    if(this.state.loading)
    {
        return(
            <div >
                    Loading Fees Structure, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center" style= {{fontWeight:"bold"}}>Fees Structure -  {_this.state.term}</h4>
                                        <h5 className ="text-center" style ={{paddingTop:"5px"}}>{_this.props.student_details.class_details.names} <br/>
                                          {_this.props.student_details.class_details.ClassType} - ( {_this.props.student_details.class_details.Year + "  "  }
                                           {_this.props.student_details.class_details.Semester})</h5>


                                        {_this.renderStructure()}



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default Structure;
